class Endpoints {
    static baseURL = process.env.REACT_APP_BASE_URL+"api/";

    static addInfo = this.baseURL + "bd/createBdList";
}
export default Endpoints;